export default "__VITE_ASSET__N4hK4AE$__"